export default __webpack_public_path__ + "9538331490d00967eca668cbeedba54d.svg";